import { createPrefixer } from '.'

const ROOT = 'ver-financiero-pg' as const
export const RESOURCE_FINANCIERO_PG = 'Financiero PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_FINANCIERO_PG,
    informes: {
        _perm: rp('informes'),
        reporteStatus: pi('reporte-status'),
        archivoBancos: pi('archivo-bancos'),
        libroBancos: pi('libro-bancos'),
        movimientosBancarios: pi('movimientos-bancarios'),
        reportePagos: pi('reporte-pagos'),
    },
    mantenimiento: {
        _perm: rp('mantenimiento'),
        bancos: pm('bancos'),
        cuentasBancarias: pm('cuentas-bancarias'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        bandejaFlujoPago: pt('bandeja-flujo-pago'),
        crearFlujoPago: pt('crear-flujo-pago'),
        aprobacionFlujoPago: pt('aprobacion-flujo-pago'),
        revisionFlujoPago: pt('revision-flujo-pago'),
        bandejaTransaccionesBancarias: pt('bandeja-transaccion-bancaria'),
        crearDeposito: pt('crear-deposito'),
        crearTransferencia: pt('crear-transferencia'),
        crearNotaCredito: pt('crear-nota-credito'),
        crearCheque: pt('crear-cheque'),
        crearNotaDebito: pt('crear-nota-debito'),
        conciliacionBancaria: pt('conciliacion-bancaria'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        nivelAprobacionFlujoPago: pc('nivel-aprobacion-flujo-pago'),
        permisoCuentaBancaria: pc('permiso-cuenta-bancaria'),
    },
}

export default permission
